import store from "@/store";
import { toLocaleDate } from "@/utils/dates";
import { toLocaleCurrency } from "@/utils/strings";
import { groupBy } from "@/utils/accounting";
import { getDictionary } from "@/utils/dictionary";
// const councils = store.state.auth.councils;
// const countries = store.state.auth.countries;
// const mandate_codes = store.state.auth.mandate_codes;
const provinceByCouncil = store.getters["auth/provinceByCouncil"];
const countryByCouncil = store.getters["auth/countryByCouncil"];

export const toRelationString = (
  relationName,
  array,
  fields,
  statuses = [0],
) => {
  let ret = [];
  let data = [];
  let statusName;
  switch (relationName) {
    case "brokers":
      statusName = "status_broker";
      break;
    case "registries":
      statusName = "status_registry";
      break;
    case "correspondences":
      statusName = "status_correspondence";
      break;
    case "address_books":
      statusName = "status_addressbook"; // <= notare l'assenza di underscore!!!
      break;
  }
  if (!Array.isArray(array)) {
    array = [array];
  }
  if (statusName) {
    // il default deve esserci
    if (statuses === null) {
      statuses = [0];
    }
    data = array.filter((el) => statuses.includes(el[statusName].value));
  } else {
    data = array;
  }

  for (let i = 0; i < data.length; i++) {
    for (let j = 0; j < fields.length; j++) {
      let parts = fields[j].split("|");
      let text = [];
      for (let k = 0; k < parts.length; k++) {
        let t;
        const parts2 = parts[k].split(".");
        // devo risolvere il codice comune con la label
        // switch (parts2.slice(-2).join(".")) {
        //   case "attributables.POB":
        //   case "attributables.CITY":
        //   case "attributables.ISPL":
        switch (parts[k]) {
          case "CITY":
          case "POB":
          case "ISPL":
            t = parts2.reduce(
              (acc, part) => acc && acc[part],
              data[i].attributables,
            );
            if (typeof t !== "undefined") {
              t = store.state.auth.councils.find((e) => e.id == t);
              if (typeof t !== "undefined" && t?.code == "ZZ") {
                t = ["CITY2"].reduce(
                  (acc, part) => acc && acc[part],
                  data[i].attributables,
                );
              } else {
                t = t?.title || "-";
              }
            }
            break;
          // vitual fields
          case "VIRTUAL_CITY_PROVINCE":
            t = ["CITY"].reduce(
              (acc, part) => acc && acc[part],
              data[i].attributables,
            );
            if (typeof t !== "undefined") t = `${provinceByCouncil(t, "code")}`;
            break;
          case "VIRTUAL_POB_PROVINCE":
            t = ["POB"].reduce(
              (acc, part) => acc && acc[part],
              data[i].attributables,
            );
            if (typeof t !== "undefined") t = provinceByCouncil(t, "code");
            break;
          case "VIRTUAL_FULLNAME":
            if (data[i][statusName].value === 0) {
              t = `${["SURN"].reduce(
                (acc, part) => acc && acc[part],
                data[i].attributables,
              )} ${["NAME"].reduce(
                (acc, part) => acc && acc[part],
                data[i].attributables,
              )}`;
            } else if (data[i][statusName].value === 1) {
              t = ["CNAM"].reduce(
                (acc, part) => acc && acc[part],
                data[i].attributables,
              );
            }
            break;
          case "VIRTUAL_POB_NATION":
            t = ["POB"].reduce(
              (acc, part) => acc && acc[part],
              data[i].attributables,
            );
            if (typeof t !== "undefined") t = countryByCouncil(t, "title");
            break;
          case "VIRTUAL_CITY_NATION":
            t = ["CITY"].reduce(
              (acc, part) => acc && acc[part],
              data[i].attributables,
            );
            if (typeof t !== "undefined") {
              t = store.state.auth.councils.find((e) => e.id == t);
              if (typeof t !== "undefined" && t?.code == "ZZ") {
                t = ["NOR"].reduce(
                  (acc, part) => acc && acc[part],
                  data[i].attributables,
                );
                if (t) {
                  const country = store.state.auth.countries.find(
                    (e) => e.id == t,
                  );
                  t = country?.title || "-";
                } else {
                  t = data[i].attributables["CITY2"] || "-";
                }
              } else {
                t = countryByCouncil(t?.id, "title") || "-";
              }
            }
            break;
          default:
            t = parts2.reduce(
              (acc, part) => acc && acc[part],
              data[i].attributables,
            );
        }
        if (t) {
          text.push(t);
        }
      }
      ret.push(text.join(" "));
    }
  }
  return ret.join(",");
};

// Icone dei contatti nelle tabelle (Bootstrap Icons "phone" ed "envelope"):
// grigie, il tipo di recapito nel title (vedi .contact-icon in _tables.scss).
const CONTACT_ICONS = {
  CELL: ["Cellulare", '<path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"/><path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>'],
  MAIL: ["Email", '<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>'],
};

export const contactIcon = (kind) => {
  const [title, paths] = CONTACT_ICONS[kind];
  return `<span class="contact-icon" title="${title}"><svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">${paths}</svg></span>`;
};

export const toInfoData = (data, type, status = null, sep = "<br/>") => {
  let ret = [];
  let value;
  let tmp;
  if (!data) {
    return "";
  }
  let statuses = status !== null ? [status] : status;
  switch (type) {
    case "brokerfullname":
      if (data.attributables.NAME && data.attributables.SURN) {
        value = `${toRelationString(
          "brokers",
          data,
          ["SURN"],
          statuses,
        )} ${toRelationString("brokers", data, ["NAME"], statuses)}`;
        if (value.replace(/\s/gm, "")) {
          ret.push(value);
        }
      }
      if (data.attributables.CNAM) {
        value = toRelationString("brokers", data, ["CNAM"], statuses);
        if (value.replace(/\s/gm, "")) {
          ret.push(value);
        }
      }
      break;
    case "broker":
      if (data.attributables.BUID && data.attributables.CNAM) {
        value = `${toRelationString(
          "brokers",
          data,
          ["BUID"],
          statuses,
        )} ${toRelationString("brokers", data, ["CNAM"], statuses)}`;
        if (value.replace(/\s/gm, "")) {
          ret.push(value);
        }
      } else if (
        data.attributables.BUID &&
        data.attributables.NAME &&
        data.attributables.SURN
      ) {
        value = `${toRelationString(
          "brokers",
          data,
          ["BUID"],
          statuses,
        )} ${toRelationString(
          "brokers",
          data,
          ["SURN"],
          statuses,
        )} ${toRelationString("brokers", data, ["NAME"], statuses)}`;
        if (value.replace(/\s/gm, "")) {
          ret.push(value);
        }
      }
      break;
    case "address":
      // ADDR
      value = `${toRelationString(
        "correspondences",
        data.correspondences,
        ["ADDR"],
        statuses,
      )}`;
      if (value.replace(/\s/gm, "")) {
        ret.push(value);
      }
      // ZIPC CITY (VIRTUAL_CITY_PROVINCE)
      tmp = `${toRelationString(
        "correspondences",
        data.correspondences,
        ["VIRTUAL_CITY_PROVINCE"],
        statuses,
      ).toUpperCase()}`;
      if (tmp) {
        tmp = tmp === "NULL" ? "" : `(${tmp})`;
      } else {
        tmp = "-";
      }

      value = `${toRelationString(
        "correspondences",
        data.correspondences,
        ["ZIPC"],
        statuses,
      )} ${toRelationString(
        "correspondences",
        data.correspondences,
        ["CITY"],
        statuses,
      )} ${tmp} ${toRelationString(
        "correspondences",
        data.correspondences,
        ["VIRTUAL_CITY_NATION"],
        statuses,
      )}`;
      if (value.replace(/[\s()-]/gm, "")) {
        ret.push(value);
      }
      break;
    case "registryfullname":
      // SURN NAME or CNAM
      if (data.status_registry.value === (status === null ? 0 : status)) {
        value = `${toRelationString(null, data, ["SURN"])} ${toRelationString(
          null,
          data,
          ["NAME"],
        )}`;
        if (value.replace(/\s/gm, "")) {
          ret.push(value);
        }
      } else if (
        data.status_registry.value === (status === null ? 1 : status)
      ) {
        value = `${toRelationString(null, data, ["CNAM"])}`;
        if (value.replace(/\s/gm, "")) {
          ret.push(value);
        }
      }
      break;
    case "registry":
      // SURN NAME or CNAM
      if (data.status_registry.value === (status === null ? 0 : status)) {
        value = `${toRelationString(null, data, ["SURN"])} ${toRelationString(
          null,
          data,
          ["NAME"],
        )}`;
        if (value.replace(/\s/gm, "")) {
          ret.push(value);
        }
      } else if (
        data.status_registry.value === (status === null ? 1 : status)
      ) {
        value = `${toRelationString(null, data, ["CNAM"])}`;
        if (value.replace(/\s/gm, "")) {
          ret.push(value);
        }
      }
      // per l'indirizzo "status" non può essere null, carico sempre la residenza
      // ADDR
      value = `${toRelationString(
        "correspondences",
        data.correspondences,
        ["ADDR"],
        [0],
      )}`;
      if (value.replace(/\s/gm, "")) {
        ret.push(value);
      }
      // ZIPC CITY (VIRTUAL_CITY_PROVINCE)
      tmp = `${toRelationString(
        "correspondences",
        data.correspondences,
        ["VIRTUAL_CITY_PROVINCE"],
        [0],
      ).toUpperCase()}`;
      if (tmp) {
        tmp = `(${tmp})`;
      } else {
        tmp = "-";
      }

      value = `${toRelationString(
        "correspondences",
        data.correspondences,
        ["ZIPC"],
        [0],
      )} ${toRelationString(
        "correspondences",
        data.correspondences,
        ["CITY"],
        [0],
      )} ${tmp} ${toRelationString(
        "correspondences",
        data.correspondences,
        ["VIRTUAL_CITY_NATION"],
        [0],
      )}`;
      if (value.replace(/[\s()-]/gm, "")) {
        ret.push(value);
      }
      break;
    case "registry_group_full":
      ret.push(
        `<strong class="grid-item-label even">Codice: </strong><span class="grid-item-value even">${
          data?.code ?? "-"
        }</span>`,
      );
      ret.push(
        `<strong class="grid-item-label odd">Descrizione: </strong><span class="grid-item-value odd">${
          data?.title ?? "-"
        }</span>`,
      );
      ret.push(
        `<strong class="grid-item-label even">Capogruppo: </strong><span class="grid-item-value even">${
          data?.coordinator?.[0]?.title ?? "-"
        }</span>`,
      );
      // ret.push(`<span>Codice: ${data?.code ?? "-"}</span>`);
      // ret.push(`<span>Descrizione: ${data?.title ?? "-"}</span>`);
      /*ret.push(
        `<span>Capogruppo: ${data?.coordinator?.[0]?.title ?? "-"}</span>`
      );*/
      break;
    case "registry_group":
      ret.push(data?.code ?? "-");
      break;
    case "insurance_ancillary":
      // descrizione
      value = data.title || "";
      if (value.replace(/\s/gm, "")) {
        ret.push(`Titolo: ${value}`);
      }
      // number
      value = data.insurance_policy.number || "";
      if (value.replace(/\s/gm, "")) {
        ret.push(`Polizza: ${value}`);
      }

      break;
    case "insurance_policy":
      // number
      value = data.number || "";
      if (value.replace(/\s/gm, "")) {
        ret.push(`Numero: ${value}`);
      }
      // titolo
      value = data.title || "";
      if (value.replace(/\s/gm, "")) {
        ret.push(`Descrizione: ${value}`);
      }
      // codice mandato
      // value = data.mandate_code || "";
      tmp = store.state.auth.mandate_codes.find(
        (e) => e.id === data.mandate_code_id,
      );
      value = "";
      if (tmp) {
        value = tmp.code;
      }
      if (value.replace(/\s/gm, "")) {
        ret.push(`Codice Mandato: ${value}`);
      }
      // SURN NAME or CNAM
      if (
        data.registry.status_registry.value === (status === null ? 0 : status)
      ) {
        value = `${toRelationString(null, data.registry, [
          "SURN",
        ])} ${toRelationString(null, data.registry, ["NAME"])}`;
        if (value.replace(/\s/gm, "")) {
          ret.push(`Contraente: ${value}`);
        }
      } else {
        value = `${toRelationString(null, data.registry, ["CNAM"])}`;
        if (value.replace(/\s/gm, "")) {
          ret.push(`Contraente: ${value}`);
        }
      }
      break;
    case "insurance_policy_ext1":
      // Contraente:
      // NOMINATIVO
      // INDIRIZZO CAP LOCALITA' PROVINCIA
      // C.F.
      // P.IVA
      // TEL.
      // CELL
      // MAIL
      // PEC
      // NOMINATIVO
      if (
        data.registry.status_registry.value === (status === null ? 0 : status)
      ) {
        value = `${toRelationString(null, data.registry, [
          "SURN",
        ])} ${toRelationString(null, data.registry, ["NAME"])}`;
        ret.push(
          `<strong class="grid-item-label even">Nominativo</strong><span class="grid-item-value even">${
            value ? value : "-"
          }</span>`,
        );
      } else {
        value = `${toRelationString(null, data.registry, ["CNAM"])}`;
        ret.push(
          `<strong class="grid-item-label even">Nominativo</strong><span class="grid-item-value even">${
            value ? value : "-"
          }</span>`,
        );
      }
      // per l'indirizzo "status" non può essere null, carico sempre la residenza
      // INDIRIZZO CAP LOCALITA' PROVINCIA
      // ADDR
      value = `${toRelationString(
        "correspondences",
        data.registry.correspondences,
        ["ADDR"],
        [0],
      )}`;
      ret.push(
        `<strong class="grid-item-label odd">Indirizzo</strong><span class="grid-item-value odd">${
          value ? value : "-"
        }</span>`,
      );
      // ZIPC
      value = toRelationString(
        "correspondences",
        data.registry.correspondences,
        ["ZIPC"],
        [0],
      );
      ret.push(
        `<strong class="grid-item-label even">CAP</strong><span class="grid-item-value even">${
          value ? value : "-"
        }</span>`,
      );
      // CITY
      value = toRelationString(
        "correspondences",
        data.registry.correspondences,
        ["CITY"],
        [0],
      );
      ret.push(
        `<strong class="grid-item-label odd">Località</strong><span class="grid-item-value odd">${
          value ? value : "-"
        }</span>`,
      );
      // VIRTUAL_CITY_PROVINCE;
      value = toRelationString(
        "correspondences",
        data.registry.correspondences,
        ["VIRTUAL_CITY_PROVINCE"],
        [0],
      ).toUpperCase();
      ret.push(
        `<strong class="grid-item-label even">Provincia</strong><span class="grid-item-value even">${
          value ? value : "-"
        }</span>`,
      );
      // C.F.
      value = toRelationString(null, data.registry, ["NINO"], 0);
      ret.push(
        `<strong class="grid-item-label odd">Codice Fiscale</strong><span class="grid-item-value odd">${
          value ? value : "-"
        }</span>`,
      );
      // P.IVA
      value = toRelationString(null, data.registry, ["CREG"], 1);
      ret.push(
        `<strong class="grid-item-label even">P. IVA</strong><span class="grid-item-value even">${
          value ? value : "-"
        }</span>`,
      );
      // TEL.
      value = `${toRelationString(null, data.registry.address_books, [
        "PHON",
      ])}`;
      ret.push(
        `<strong class="grid-item-label odd">Telefono</strong><span class="grid-item-value odd">${
          value ? value : "-"
        }</span>`,
      );
      // CELL
      value = `${toRelationString(null, data.registry.address_books, [
        "CELL",
      ])}`;
      ret.push(
        `<strong class="grid-item-label even">Cellulare</strong><span class="grid-item-value even">${
          value ? value : "-"
        }</span>`,
      );
      // MAIL
      value = `${toRelationString(null, data.registry.address_books, [
        "MAIL",
      ])}`;
      ret.push(
        `<strong class="grid-item-label odd">E-mail</strong><span class="grid-item-value odd">${
          value ? value : "-"
        }</span>`,
      );
      // PEC
      value = `${toRelationString(null, data.registry.address_books, ["PEC"])}`;
      ret.push(
        `<strong class="grid-item-label even">PEC</strong><span class="grid-item-value even">${
          value ? value : "-"
        }</span>`,
      );
      break;
    case "insurance_policy_ext2":
      // Polizza:
      // CODICE COMPAGNIA
      // NUMERO POLIZZA
      // RAMO
      // PRODOTTO
      // DATA COPERTURA
      // DATA SCADENZA
      // STATO POLIZZA
      // CODICE + DESCR. PRODUTTORE
      // CODICE COMPAGNIA
      value = data.insurer ? data.insurer.code : "";
      if (value.replace(/\s/gm, "")) {
        ret.push(
          `<strong class="grid-item-label even">Codice Compagnia</strong><span class="grid-item-value even">${
            value ? value : "-"
          }</span>`,
        );
      }
      // NUMERO POLIZZA
      value = data.number || "";
      ret.push(
        `<strong class="grid-item-label odd">Numero Polizza</strong><span class="grid-item-value odd">${
          value ? value : "-"
        }</span>`,
      );
      // RAMO
      value = data.insurance_risk.risk_branch.formatted_title || "";
      ret.push(
        `<strong class="grid-item-label even">Ramo</strong><span class="grid-item-value even">${
          value ? value : "-"
        }</span>`,
      );
      // PRODOTTO
      value = data.insurance_risk.formatted_title || "";
      ret.push(
        `<strong class="grid-item-label odd">Prodotto</strong><span class="grid-item-value odd">${
          value ? value : "-"
        }</span>`,
      );
      // DATA COPERTURA
      value = toLocaleDate(data.covered_at);
      ret.push(
        `<strong class="grid-item-label even">Data Copertura</strong><span class="grid-item-value even">${
          value ? value : "-"
        }</span>`,
      );
      // DATA SCADENZA
      value = toLocaleDate(data.expired_at);
      ret.push(
        `<strong class="grid-item-label odd">Data Scadenza</strong><span class="grid-item-value odd">${
          value ? value : "-"
        }</span>`,
      );
      // STATO POLIZZA
      value = data.status_policy.text;
      ret.push(
        `<strong class="grid-item-label even">Stato Polizza</strong><span class="grid-item-value even">${
          value ? value : "-"
        }</span>`,
      );
      // CODICE + DESCR. PRODUTTORE
      value = data.broker
        ? `${toRelationString(null, data.broker, ["BUID"])} ${
            data.broker.formatted_title
          }`
        : "";
      ret.push(
        `<strong class="grid-item-label odd">Produttore</strong><span  class="grid-item-value odd">${
          value ? value : "-"
        }</span>`,
      );
      break;
    case "agency_contacts":
      // SURN NAME
      value = `${toRelationString(null, data, ["SURN"])} ${toRelationString(
        null,
        data,
        ["NAME"],
      )}`;
      if (value.replace(/\s/gm, "")) {
        ret.push(`Cognome/Nome: ${value}`);
      }
      // CNAM
      value = toRelationString(null, data, ["CREG"]);
      if (value.replace(/\s/gm, "")) {
        ret.push(`Partita IVA: ${value}`);
      }
      // NINO
      value = toRelationString(null, data, ["NINO"]);
      if (value.replace(/\s/gm, "")) {
        ret.push(`Cod.Fiscale: ${value}`);
      }
      // CREG
      value = toRelationString(null, data, ["CNAM"]);
      if (value.replace(/\s/gm, "")) {
        ret.push(`Rag.Sociale: ${value}`);
      }
      break;
    // Contatti nelle tabelle: solo cellulare ed email, sempre visibili e
    // indicati da un'icona; gli altri recapiti vanno nel title della cella
    // ("address_books").
    case "primary_contacts":
      value = `${toRelationString(null, data.address_books, ["CELL"])}`;
      if (value.replace(/\s/gm, "")) {
        ret.push(`${contactIcon("CELL")}${value}`);
      }
      value = `${toRelationString(null, data.address_books, ["MAIL"])}`;
      if (value.replace(/\s/gm, "")) {
        ret.push(`${contactIcon("MAIL")}${value}`);
      }
      break;
    case "address_books":
      // TEL.
      value = `${toRelationString(null, data.address_books, ["PHON"])}`;
      if (value.replace(/\s/gm, "")) {
        ret.push(`Tel.: ${value}`);
      }
      // CELL
      value = `${toRelationString(null, data.address_books, ["CELL"])}`;
      if (value.replace(/\s/gm, "")) {
        ret.push(`Cell.: ${value}`);
      }
      // MAIL
      value = `${toRelationString(null, data.address_books, ["MAIL"])}`;
      if (value.replace(/\s/gm, "")) {
        ret.push(`Email: ${value}`);
      }
      // PEC
      value = `${toRelationString(null, data.address_books, ["PEC"])}`;
      if (value.replace(/\s/gm, "")) {
        ret.push(`PEC: ${value}`);
      }
      break;
  }
  return ret.join(sep);
};

export const toTooltipTask = (
  array,
  header,
  fields = [
    { label: "Titolo", key: "title" },
    { label: "Descrizione", key: "description" },
    {
      label: "Ultimo aggiornamento",
      key: "last_update",
    },
  ],
) => {
  let ret = {
    title: "",
    placement: "left",
    html: true /*trigger: 'click hover'*/,
  };
  if (!array || !array.length) {
    return ret;
  }
  let content = "<table class='amount-tooltip'><thead>";
  // thead
  content += "<tr>";
  for (const field of fields) {
    content += `<th>${field.label}</th>`;
  }
  content += "</tr></thead><tbody>";
  // tbody
  for (const obj of array) {
    content += "<tr>";
    for (const field of fields) {
      let formatted;
      if (field.formatter instanceof Function) {
        formatted = field.formatter(obj[field.key]);
      }
      content += `<td>${
        obj[field.key] != null ? (formatted ? formatted : obj[field.key]) : ""
      }</td>`;
    }
    content += "</tr>";
  }
  content += "</tbody></table>";
  ret.title = "<b>" + header + "</b><br/>" + content;
  return ret;
};

export const toGroupedTooltipTask = (
  array,
  fields = [
    // { label: "Entità", key: "entity" },
    { label: "Titolo", key: "title" },
    { label: "Descrizione", key: "description" },
    { label: "Ultimo aggiornamento", key: "last_update" },
    { label: "Creato da", key: "owner" },
    { label: "Data Creazione", key: "created_at" },
  ],
) => {
  let ret = {
    title: "",
    placement: "left",
    html: true /*trigger: 'click hover'*/,
  };
  if (!array || !array.length) {
    return ret;
  }
  let content = "<table class='amount-tooltip'><thead>";
  // thead
  content += "<tr>";
  // add static th(Entità)
  content += `<th style="text-align: left">Entità</th>`;
  // add all others
  for (const field of fields) {
    content += `<th style="text-align: left">${field.label}</th>`;
  }
  content += "</tr></thead><tbody>";
  // #573 disinguere le note per entità: pivot.taskable_type
  // const groupByTaskable = groupBy("taskable_type", "pivot");
  const groupByTaskable = groupBy("pivot.taskable_type");
  const dataByTaskable = groupByTaskable(array);
  for (const [taskable, tasks] of Object.entries(dataByTaskable)) {
    let header = getTaskableLabel(taskable);
    // content +=
    //   `<tr><td style="text-align: left" colspan="${fields.length}">` +
    //   header +
    //   "</td></tr>";
    // tbody
    for (const obj of tasks) {
      content += "<tr>";
      // add static td
      content += `<td style="text-align: left">${header}</td>`;
      // add all others
      for (const field of fields) {
        content += `<td style="text-align: left">${
          obj[field.key] != null ? obj[field.key] : ""
        }</td>`;
      }
      content += "</tr>";
    }
  }
  content += "</tbody></table>";
  ret.title = content;
  return ret;
};
/**
 *
 * @param {*} data
 * @returns Array
 *   data:
 *  "broker_wht": "4.6",      percentuale WHT del broker
    "gross": 2820,            totale entryDetails.gross
    "deferred": -3,           entryDetails.treasury = SS
    "deposit": 0,             entryDetails.treasury = AC
    "purchase": 9.27,         saler_prov_purchase
    "take": 42.35,            saler_prov_take
    "fees": 0,                saler_fee_take
    "purchase_tax": 9.27,     idem dove taxable = Y
    "take_tax": 42.35,        idem dove taxable = Y
    "deduction": 0,           differenza prov * percentuale
    "premium": 2768.38,       totale finale
 *
 *  logic:
    this.summary.ritenuta_perc = parseFloat(data.broker_wht);
    this.summary.entrate = data.gross;
    this.summary.sospesi = data.deferred;
    this.summary.acconti = data.deposit;
    this.summary.provvigioni = data.purchase + data.take;
    this.summary.di_cui = data.purchase_tax + data.take_tax;
    this.summary.di_cui_diritti = data.fees;
    this.summary.ritenuta = data.deduction;
    this.summary.da_liquidare = data.purchase + data.take - data.deduction;
    this.summary.saldo =
      data.gross -
      data.deposit -
      (data.purchase + data.take) +
      data.deduction;
 *
      returns
    [
      { [this.getDictionary("premiums")]: this.summary.entrate },
      {
        [this.getDictionary("of_which_deferred_to_collect")]: this.summary
          .sospesi,
      },
      { [this.getDictionary("advance_payments")]: this.summary.acconti },
      { [this.getDictionary("commissions")]: this.summary.provvigioni },
      { [this.getDictionary("of_which_not_taxable")]: this.summary.di_cui },
      { [this.getDictionary("fees")]: this.summary.di_cui_diritti }, // #1112
      {
        [`${this.getDictionary("deduction")} (${
          this.summary.ritenuta_perc
        }%)`]: this.summary.ritenuta,
      },
      {
        [this.getDictionary("commissions_to_liquidate")]: this.summary
          .da_liquidare,
      },
      { [this.getDictionary("premiums_balance")]: this.summary.saldo },
    ]
 */
const transformTotalizers = (data) => {
  let ret = [];
  ret.push({ [getDictionary("premiums")]: data.gross });
  ret.push({
    [getDictionary("of_which_deferred_to_collect")]: data.deferred,
  });
  ret.push({ [getDictionary("advance_payments")]: data.deposit });
  ret.push({ [getDictionary("commissions")]: data.purchase + data.take });
  ret.push({
    [getDictionary("of_which_not_taxable")]: data.purchase_tax + data.take_tax,
  });
  ret.push({ [getDictionary("fees")]: data.fees }); // #1112
  ret.push({
    [`${getDictionary("deduction")} (${data.broker_wht}%)`]: data.deduction,
  });
  ret.push({
    [getDictionary("commissions_to_liquidate")]:
      data.purchase + data.take - data.deduction + data.fees,
  });
  ret.push({
    [getDictionary("premiums_balance")]:
      data.gross /* - data.deposit */ -
      (data.purchase + data.take) +
      data.deduction -
      data.fees,
  });
  return ret;
};
/**
 *
 * @param {*} data Array|Object
 * @param {*} sep
 * @returns String
 */
export const toTotalizers = (data, sep = "<br/>", skip = false) => {
  console.log("toTotalizers - skip: ", skip);
  let t = [];
  // old fashion: data is a json "blob" stored in a db field as array of objects
  // REVIEW: in future "data" will always be an Object, so transformTotalizers has to be called every time
  if (!Array.isArray(data)) {
    // new fashion: data is broker_statement model (object)
    data = transformTotalizers(data);
  }
  // from now on, everything is same as before
  data.forEach((e) => {
    if (
      !skip ||
      (skip &&
        ![
          `Di cui sospesi da incassare`,
          `Acconti`,
          `Di cui non soggette a ritenuta d'acconto`,
          `Ritenuta d'acconto`,
        ].some((label) => Object.keys(e)?.[0]?.startsWith(label)))
    ) {
      for (const [k, v] of Object.entries(e)) {
        t.push(`${k}: ${toLocaleCurrency(v)}`);
      }
    }
  });
  return t.join(sep);
};

/**
 * Same as toTotalizers, but returns structured entries [{ label, value }]
 * (value already formatted as currency) so the caller can render an aligned grid.
 * @param {*} data Array|Object
 * @param {*} skip Boolean
 * @returns {{label: string, value: string}[]}
 */
export const toTotalizersList = (data, skip = false) => {
  let t = [];
  if (!Array.isArray(data)) {
    data = transformTotalizers(data);
  }
  data.forEach((e) => {
    if (
      !skip ||
      (skip &&
        ![
          `Di cui sospesi da incassare`,
          `Acconti`,
          `Di cui non soggette a ritenuta d'acconto`,
          `Ritenuta d'acconto`,
        ].some((label) => Object.keys(e)?.[0]?.startsWith(label)))
    ) {
      for (const [k, v] of Object.entries(e)) {
        t.push({ label: k, value: toLocaleCurrency(v) });
      }
    }
  });
  return t;
};

export const getTaskableLabel = (taskable) => {
  // "App\Models\Registry"
  let ret = "";
  let s = taskable.split("\\");
  switch (s[s.length - 1]) {
    case "Registry":
      ret = "Anagrafica";
      break;
    case "InsuranceAncillary":
      ret = "Titolo";
      break;
    case "InsurancePolicy":
      ret = "Polizza";
      break;
    default:
      break;
  }
  return ret;
};

export const getTaskableEntity = (taskable) => {
  // "App\Models\Registry"
  let ret = "";
  let s = taskable.split("\\");
  switch (s[s.length - 1]) {
    case "Registry":
      ret = "registry";
      break;
    case "InsuranceAncillary":
      ret = "insurance_ancillary";
      break;
    case "InsurancePolicy":
      ret = "insurance_policy";
      break;
    default:
      break;
  }
  return ret;
};

export const joinValues = (
  array = [],
  separator = "-",
  defaultNull = "",
  skipNull = false,
) => {
  let tempArray = [];

  for (const element of array) {
    if (element) {
      tempArray.push(element);
    }
    if (element === null && !skipNull) {
      tempArray.push(defaultNull);
    }
  }

  return tempArray.join(separator);
};

export const findAndGet = (array = [], findField, value, returnField) => {
  const found = array.find((e) => e[findField] === value);
  return found ? found[returnField] : null;
};
// module.exports = {
//   toRelationString,
// };
